var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavingFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.45C1.5 2.02996 1.5 1.81994 1.58175 1.65951C1.65365 1.51839 1.76839 1.40365 1.90951 1.33175C2.06994 1.25 2.27996 1.25 2.7 1.25H15.3C15.72 1.25 15.9301 1.25 16.0905 1.33175C16.2316 1.40365 16.3463 1.51839 16.4183 1.65951C16.5 1.81994 16.5 2.02996 16.5 2.45V2.95205C16.5 3.15364 16.5 3.25444 16.4754 3.34817C16.4535 3.43123 16.4176 3.50993 16.3691 3.58082C16.3144 3.66082 16.2383 3.72684 16.0859 3.85887L11.2891 8.01613C11.1367 8.14816 11.0606 8.21418 11.0059 8.29418C10.9574 8.36507 10.9215 8.44377 10.8996 8.52683C10.875 8.62056 10.875 8.72136 10.875 8.92295V12.8438C10.875 12.9905 10.875 13.0638 10.8513 13.1272C10.8304 13.1832 10.7964 13.2334 10.7522 13.2736C10.7021 13.3192 10.634 13.3464 10.4978 13.4009L7.94783 14.4209C7.67218 14.5311 7.53435 14.5863 7.4237 14.5633C7.32695 14.5432 7.24204 14.4857 7.18744 14.4033C7.125 14.3091 7.125 14.1607 7.125 13.8638V8.92295C7.125 8.72136 7.125 8.62056 7.10037 8.52683C7.07854 8.44377 7.0426 8.36507 6.99413 8.29418C6.93943 8.21418 6.86326 8.14816 6.71092 8.01613L1.91408 3.85887C1.76174 3.72684 1.68557 3.66082 1.63087 3.58082C1.5824 3.50993 1.54646 3.43123 1.52463 3.34817C1.5 3.25444 1.5 3.15364 1.5 2.95205V2.45Z",
    stroke: "#3C404A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingFilter);
export default __webpack_public_path__ + "static/media/savingFilter.555b90cb4e86f2fd99203c21e9f4e56d.svg";
export { ForwardRef as ReactComponent };